import ArrowRightLight from '@/images/light/Arrow-Right.svg';
import ArrowRightDark from '@/images/dark/Arrow-Right.svg';
import LockRoundOpenLight from '@/images/light/Lock-round-open.svg';
import LockRoundOpenDark from '@/images/dark/Lock-round-open.svg';
import SuccessLight from '@/images/light/Success.svg';
import SuccessDark from '@/images/dark/Success.svg';
import accountIconLight from '@/images/light/accountIcon.svg';
import accountIconDark from '@/images/dark/accountIcon.svg';
import accountIconGreyLight from '@/images/light/accountIconGrey.svg';
import accountIconGreyDark from '@/images/dark/accountIconGrey.svg';
import accountIconYellowLight from '@/images/light/accountIconYellow.svg';
import accountIconYellowDark from '@/images/dark/accountIconYellow.svg';
import actionsIconGreyLight from '@/images/light/actionsIconGrey.svg';
import actionsIconGreyDark from '@/images/dark/actionsIconGrey.svg';
import actionsIconYellowLight from '@/images/light/actionsIconYellow.svg';
import actionsIconYellowDark from '@/images/dark/actionsIconYellow.svg';
import alertIconLight from '@/images/light/alertIcon.svg';
import alertIconDark from '@/images/dark/alertIcon.svg';
import beeIconLight from '@/images/light/beeIcon.svg';
import beeIconDark from '@/images/dark/beeIcon.svg';
import beneficiariesIconLight from '@/images/light/beneficiariesIcon.svg';
import beneficiariesIconDark from '@/images/dark/beneficiariesIcon.svg';
import biometricsIconLight from '@/images/light/biometricsIcon.svg';
import biometricsIconDark from '@/images/dark/biometricsIcon.svg';
import blobDenyLight from '@/images/light/blob-deny.svg';
import blobDenyDark from '@/images/dark/blob-deny.svg';
import blueInfoIconLight from '@/images/light/blueInfoIcon.svg';
import blueInfoIconDark from '@/images/dark/blueInfoIcon.svg';
import briefcaseIconLight from '@/images/light/briefcaseIcon.svg';
import briefcaseIconDark from '@/images/dark/briefcaseIcon.svg';
import bulletCheckmarkLight from '@/images/light/bullet-checkmark.svg';
import bulletCheckmarkDark from '@/images/dark/bullet-checkmark.svg';
import circleBorderLight from '@/images/light/circle-border.svg';
import circleBorderDark from '@/images/dark/circle-border.svg';
import closeLight from '@/images/light/close.svg';
import closeDark from '@/images/dark/close.svg';
import cloudGreenTickLight from '@/images/light/cloud-green-tick.svg';
import cloudGreenTickDark from '@/images/dark/cloud-green-tick.svg';
import cloudTickLight from '@/images/light/cloud-tick.svg';
import cloudTickDark from '@/images/dark/cloud-tick.svg';
import connectIconLight from '@/images/light/connectIcon.svg';
import connectIconDark from '@/images/dark/connectIcon.svg';
import darkGreyInfoIconLight from '@/images/light/darkGreyInfoIcon.svg';
import darkGreyInfoIconDark from '@/images/dark/darkGreyInfoIcon.svg';
import discoverIconGreyLight from '@/images/light/discoverIconGrey.svg';
import discoverIconGreyDark from '@/images/dark/discoverIconGrey.svg';
import discoverIconYellowLight from '@/images/light/discoverIconYellow.svg';
import discoverIconYellowDark from '@/images/dark/discoverIconYellow.svg';
import documentResourcesIconLight from '@/images/light/documentResourcesIcon.svg';
import documentResourcesIconDark from '@/images/dark/documentResourcesIcon.svg';
import downFilledLight from '@/images/light/down-filled.svg';
import downFilledDark from '@/images/dark/down-filled.svg';
import emailLight from '@/images/light/email.svg';
import emailDark from '@/images/dark/email.svg';
import emailYellowIconLight from '@/images/light/emailYellowIcon.svg';
import emailYellowIconDark from '@/images/dark/emailYellowIcon.svg';
import errorIconLight from '@/images/light/error-icon.svg';
import errorIconDark from '@/images/dark/error-icon.svg';
import errorIcon_Light from '@/images/light/errorIcon.svg';
import errorIcon_Dark from '@/images/dark/errorIcon.svg';
import faceIdLight from '@/images/light/face-id.svg';
import faceIdDark from '@/images/dark/face-id.svg';
import fingerprintLight from '@/images/light/fingerprint.svg';
import fingerprintDark from '@/images/dark/fingerprint.svg';
import folderIconLight from '@/images/light/folderIcon.svg';
import folderIconDark from '@/images/dark/folderIcon.svg';
import giftIconLight from '@/images/light/gift.svg';
import giftIconDark from '@/images/dark/gift.svg';
import healthcareIconLight from '@/images/light/healthcareIcon.svg';
import healthcareIconDark from '@/images/dark/healthcareIcon.svg';
import hybridAppIntroScreenOneLight from '@/images/light/hybrid-app-intro-screen-one.svg';
import hybridAppIntroScreenOneDark from '@/images/dark/hybrid-app-intro-screen-one.svg';
import hybridAppIntroScreenThreeLight from '@/images/light/hybrid-app-intro-screen-three.svg';
import hybridAppIntroScreenThreeDark from '@/images/dark/hybrid-app-intro-screen-three.svg';
import hybridAppIntroScreenTwoLight from '@/images/light/hybrid-app-intro-screen-two.svg';
import hybridAppIntroScreenTwoDark from '@/images/dark/hybrid-app-intro-screen-two.svg';
import iconDrivingLicenseLight from '@/images/light/icon-driving-license.svg';
import iconDrivingLicenseDark from '@/images/dark/icon-driving-license.svg';
import iconHideLight from '@/images/light/icon-hide.svg';
import iconHideDark from '@/images/dark/icon-hide.svg';
import iconPassportLight from '@/images/light/icon-passport.svg';
import iconPassportDark from '@/images/dark/icon-passport.svg';
import iconShowLight from '@/images/light/icon-show.svg';
import iconShowDark from '@/images/dark/icon-show.svg';
import laptopIconLight from '@/images/light/laptopIcon.svg';
import laptopIconDark from '@/images/dark/laptopIcon.svg';
import lightGreyInfoIconLight from '@/images/light/lightGreyInfoIcon.svg';
import lightGreyInfoIconDark from '@/images/dark/lightGreyInfoIcon.svg';
import limitedCompanyIconLight from '@/images/light/limitedCompanyIcon.svg';
import limitedCompanyIconDark from '@/images/dark/limitedCompanyIcon.svg';
import manageLight from '@/images/light/manage.svg';
import manageDark from '@/images/dark/manage.svg';
import mobileChecklistIconLight from '@/images/light/mobileChecklistIcon.svg';
import mobileChecklistIconDark from '@/images/dark/mobileChecklistIcon.svg';
import moneyStacksIconLight from '@/images/light/moneyStacksIcon.svg';
import moneyStacksIconDark from '@/images/dark/moneyStacksIcon.svg';
import moreMeatballMenuLight from '@/images/light/more-meatball-menu.svg';
import moreMeatballMenuDark from '@/images/dark/more-meatball-menu.svg';
import myPensionsIconGreyLight from '@/images/light/myPensionsIconGrey.svg';
import myPensionsIconGreyDark from '@/images/dark/myPensionsIconGrey.svg';
import myPensionsIconYellowLight from '@/images/light/myPensionsIconYellow.svg';
import myPensionsIconYellowDark from '@/images/dark/myPensionsIconYellow.svg';
import noNetworkConnectionLight from '@/images/light/noNetworkConnection.svg';
import noNetworkConnectionDark from '@/images/dark/noNetworkConnection.svg';
import pastPerformanceIconLight from '@/images/light/pastPerformanceIcon.svg';
import pastPerformanceIconDark from '@/images/dark/pastPerformanceIcon.svg';
import planningIconGreyLight from '@/images/light/planning-icon-grey.svg';
import planningIconGreyDark from '@/images/dark/planning-icon-grey.svg';
import planningIconYellowLight from '@/images/light/planning-icon-yellow.svg';
import planningIconYellowDark from '@/images/dark/planning-icon-yellow.svg';
import pensionConfidentPodcastLogoLight from '@/images/light/pension-confident-podcast-logo.svg';
import pensionConfidentPodcastLogoDark from '@/images/dark/pension-confident-podcast-logo.svg';
import pensionbeeLogoLight from '@/images/light/pensionbeeLogo.svg';
import pensionbeeLogoDark from '@/images/dark/pensionbeeLogo.svg';
import pensionbeelogoTransparentLight from '@/images/light/pensionbeelogo-transparent.svg';
import pensionbeelogoTransparentDark from '@/images/dark/pensionbeelogo-transparent.svg';
import piggyBankLight from '@/images/light/piggy-bank.svg';
import piggyBankDark from '@/images/dark/piggy-bank.svg';
import piggyBankIconLight from '@/images/light/piggyBankIcon.svg';
import piggyBankIconDark from '@/images/dark/piggyBankIcon.svg';
import pinIconLight from '@/images/light/pinIcon.svg';
import pinIconDark from '@/images/dark/pinIcon.svg';
import planInfoIconLight from '@/images/light/planInfoIcon.svg';
import planInfoIconDark from '@/images/dark/planInfoIcon.svg';
import playLight from '@/images/light/play.svg';
import playDark from '@/images/dark/play.svg';
import playIconLight from '@/images/light/playIcon.svg';
import playIconDark from '@/images/dark/playIcon.svg';
import podcastIconLight from '@/images/light/podcastIcon.svg';
import podcastIconDark from '@/images/dark/podcastIcon.svg';
import portfolioMoneyLight from '@/images/light/portfolio-money.svg';
import portfolioMoneyDark from '@/images/dark/portfolio-money.svg';
import profileIconLight from '@/images/light/profileIcon.svg';
import profileIconDark from '@/images/dark/profileIcon.svg';
import referAFriendLight from '@/images/light/refer-a-friend.svg';
import referAFriendDark from '@/images/dark/refer-a-friend.svg';
import retirementPlannerIconLight from '@/images/light/retirementPlannerIcon.svg';
import retirementPlannerIconDark from '@/images/dark/retirementPlannerIcon.svg';
import spotChatLight from '@/images/light/spot-chat.svg';
import spotChatDark from '@/images/dark/spot-chat.svg';
import spotCheckingDetailsLight from '@/images/light/spot-checking-details.svg';
import spotCheckingDetailsDark from '@/images/dark/spot-checking-details.svg';
import spotCombinePensionsLight from '@/images/light/spot-combine-pensions.svg';
import spotCombinePensionsDark from '@/images/dark/spot-combine-pensions.svg';
import spotCustomerServiceLight from '@/images/light/spot-customer-service.svg';
import spotCustomerServiceDark from '@/images/dark/spot-customer-service.svg';
import spotDenyLight from '@/images/light/spot-deny.svg';
import spotDenyDark from '@/images/dark/spot-deny.svg';
import spotDiversePortfolioLight from '@/images/light/spot-diverse-portfolio.svg';
import spotDiversePortfolioDark from '@/images/dark/spot-diverse-portfolio.svg';
import spotExpertLight from '@/images/light/spot-expert.svg';
import spotExpertDark from '@/images/dark/spot-expert.svg';
import spotExpertApprovedLight from '@/images/light/spot-expert-approved.svg';
import spotExpertApprovedDark from '@/images/dark/spot-expert-approved.svg';
import spotGoldLight from '@/images/light/spot-gold.svg';
import spotGoldDark from '@/images/dark/spot-gold.svg';
import spotIcons60pxLight from '@/images/light/spot-icons-60px.svg';
import spotIcons60pxDark from '@/images/dark/spot-icons-60px.svg';
import spotLaptopLight from '@/images/light/spot-laptop.svg';
import spotLaptopDark from '@/images/dark/spot-laptop.svg';
import spotLaptopCompareLight from '@/images/light/spot-laptop-compare.svg';
import spotLaptopCompareDark from '@/images/dark/spot-laptop-compare.svg';
import spotMoneyBalancingLight from '@/images/light/spot-money-balancing.svg';
import spotMoneyBalancingDark from '@/images/dark/spot-money-balancing.svg';
import spotMonitoringLight from '@/images/light/spot-monitoring.svg';
import spotMonitoringDark from '@/images/dark/spot-monitoring.svg';
import spotPhoneLight from '@/images/light/spot-phone.svg';
import spotPhoneDark from '@/images/dark/spot-phone.svg';
import spotPiggyBankLight from '@/images/light/spot-piggy-bank.svg';
import spotPiggyBankDark from '@/images/dark/spot-piggy-bank.svg';
import spotPlusSignLight from '@/images/light/spot-plus-sign.svg';
import spotPlusSignDark from '@/images/dark/spot-plus-sign.svg';
import spotRemoteWorkingLight from '@/images/light/spot-remote-working.svg';
import spotRemoteWorkingDark from '@/images/dark/spot-remote-working.svg';
import spotSearchLight from '@/images/light/spot-search.svg';
import spotSearchDark from '@/images/dark/spot-search.svg';
import spotSelfEmployedLight from '@/images/light/spot-self-employed.svg';
import spotSelfEmployedDark from '@/images/dark/spot-self-employed.svg';
import spotThumbUpLight from '@/images/light/spot-thumb-up.svg';
import spotThumbUpDark from '@/images/dark/spot-thumb-up.svg';
import spotTickLight from '@/images/light/spot-tick.svg';
import spotTickDark from '@/images/dark/spot-tick.svg';
import spotTransferMoneyLight from '@/images/light/spot-transfer-money.svg';
import spotTransferMoneyDark from '@/images/dark/spot-transfer-money.svg';
import spotVerifyIdentityLight from '@/images/light/spot-verify-identity.svg';
import spotVerifyIdentityDark from '@/images/dark/spot-verify-identity.svg';
import spotVillageLight from '@/images/light/spot-village.svg';
import spotVillageDark from '@/images/dark/spot-village.svg';
import spotWithdrawLight from '@/images/light/spot-withdraw.svg';
import spotWithdrawDark from '@/images/dark/spot-withdraw.svg';
import spotYoutubeVideoLight from '@/images/light/spot-youtube-video.svg';
import spotYoutubeVideoDark from '@/images/dark/spot-youtube-video.svg';
import summaryIconGreyLight from '@/images/light/summaryIconGrey.svg';
import summaryIconGreyDark from '@/images/dark/summaryIconGrey.svg';
import summaryIconYellowLight from '@/images/light/summaryIconYellow.svg';
import summaryIconYellowDark from '@/images/dark/summaryIconYellow.svg';
import supportIconLight from '@/images/light/supportIcon.svg';
import supportIconDark from '@/images/dark/supportIcon.svg';
import telephoneYellowIconLight from '@/images/light/telephoneYellowIcon.svg';
import telephoneYellowIconDark from '@/images/dark/telephoneYellowIcon.svg';
import thumbsUpIconLight from '@/images/light/thumbsUpIcon.svg';
import thumbsUpIconDark from '@/images/dark/thumbsUpIcon.svg';
import tooltipLight from '@/images/light/tooltip.svg';
import tooltipDark from '@/images/dark/tooltip.svg';
import transferAndContributionBreakdownIconLight from '@/images/light/transferAndContributionBreakdownIcon.svg';
import transferAndContributionBreakdownIconDark from '@/images/dark/transferAndContributionBreakdownIcon.svg';
import trustPilotLogoLight from '@/images/light/trust-pilot-logo.svg';
import trustPilotLogoDark from '@/images/dark/trust-pilot-logo.svg';
import trustPilotStarsLight from '@/images/light/trust-pilot-stars.svg';
import trustPilotStarsDark from '@/images/dark/trust-pilot-stars.svg';
import twoFAIconLight from '@/images/light/twoFAIcon.svg';
import twoFAIconDark from '@/images/dark/twoFAIcon.svg';
import upFilledLight from '@/images/light/up-filled.svg';
import upFilledDark from '@/images/dark/up-filled.svg';
import uploadSuccessfulLight from '@/images/light/upload-successful.svg';
import uploadSuccessfulDark from '@/images/dark/upload-successful.svg';
import worldwideLight from '@/images/light/worldwide.svg';
import worldwideDark from '@/images/dark/worldwide.svg';
import hsbcLight from '@/images/light/hsbc.svg';
import hsbcDark from '@/images/dark/hsbc.svg';
import blackRockLight from '@/images/light/black-rock.svg';
import blackRockDark from '@/images/dark/black-rock.svg';
import stateStreetLight from '@/images/light/state-street.svg';
import stateStreetDark from '@/images/dark/state-street.svg';
import plaidLight from '@/images/light/plaid.svg';
import plaidDark from '@/images/dark/plaid.svg';
import pwResetIconDark from '@/images/dark/pwResetIcon.svg';
import pwResetIconLight from '@/images/light/pwResetIcon.svg';

/**
 * Registry of every themed SVG, keyed by its file basename. Each entry holds a
 * `light` and `dark` variant (generated from the original single-file SVGs by
 * scripts/split-themed-svgs.mjs). `ThemedImage` is the only place that decides
 * which variant to render — see src/domains/theme/ThemedImage.tsx.
 */
export const themedImages = {
  'Arrow-Right': { light: ArrowRightLight, dark: ArrowRightDark },
  'Lock-round-open': { light: LockRoundOpenLight, dark: LockRoundOpenDark },
  Success: { light: SuccessLight, dark: SuccessDark },
  accountIcon: { light: accountIconLight, dark: accountIconDark },
  accountIconGrey: { light: accountIconGreyLight, dark: accountIconGreyDark },
  accountIconYellow: {
    light: accountIconYellowLight,
    dark: accountIconYellowDark,
  },
  actionsIconGrey: { light: actionsIconGreyLight, dark: actionsIconGreyDark },
  actionsIconYellow: {
    light: actionsIconYellowLight,
    dark: actionsIconYellowDark,
  },
  alertIcon: { light: alertIconLight, dark: alertIconDark },
  beeIcon: { light: beeIconLight, dark: beeIconDark },
  beneficiariesIcon: {
    light: beneficiariesIconLight,
    dark: beneficiariesIconDark,
  },
  biometricsIcon: { light: biometricsIconLight, dark: biometricsIconDark },
  'blob-deny': { light: blobDenyLight, dark: blobDenyDark },
  blueInfoIcon: { light: blueInfoIconLight, dark: blueInfoIconDark },
  briefcaseIcon: { light: briefcaseIconLight, dark: briefcaseIconDark },
  'bullet-checkmark': {
    light: bulletCheckmarkLight,
    dark: bulletCheckmarkDark,
  },
  'circle-border': { light: circleBorderLight, dark: circleBorderDark },
  close: { light: closeLight, dark: closeDark },
  'cloud-green-tick': { light: cloudGreenTickLight, dark: cloudGreenTickDark },
  'cloud-tick': { light: cloudTickLight, dark: cloudTickDark },
  connectIcon: { light: connectIconLight, dark: connectIconDark },
  darkGreyInfoIcon: {
    light: darkGreyInfoIconLight,
    dark: darkGreyInfoIconDark,
  },
  discoverIconGrey: {
    light: discoverIconGreyLight,
    dark: discoverIconGreyDark,
  },
  discoverIconYellow: {
    light: discoverIconYellowLight,
    dark: discoverIconYellowDark,
  },
  documentResourcesIcon: {
    light: documentResourcesIconLight,
    dark: documentResourcesIconDark,
  },
  'down-filled': { light: downFilledLight, dark: downFilledDark },
  email: { light: emailLight, dark: emailDark },
  emailYellowIcon: { light: emailYellowIconLight, dark: emailYellowIconDark },
  'error-icon': { light: errorIconLight, dark: errorIconDark },
  errorIcon: { light: errorIcon_Light, dark: errorIcon_Dark },
  'face-id': { light: faceIdLight, dark: faceIdDark },
  fingerprint: { light: fingerprintLight, dark: fingerprintDark },
  folderIcon: { light: folderIconLight, dark: folderIconDark },
  giftIcon: { light: giftIconLight, dark: giftIconDark },
  healthcareIcon: { light: healthcareIconLight, dark: healthcareIconDark },
  'hybrid-app-intro-screen-one': {
    light: hybridAppIntroScreenOneLight,
    dark: hybridAppIntroScreenOneDark,
  },
  'hybrid-app-intro-screen-three': {
    light: hybridAppIntroScreenThreeLight,
    dark: hybridAppIntroScreenThreeDark,
  },
  'hybrid-app-intro-screen-two': {
    light: hybridAppIntroScreenTwoLight,
    dark: hybridAppIntroScreenTwoDark,
  },
  'icon-driving-license': {
    light: iconDrivingLicenseLight,
    dark: iconDrivingLicenseDark,
  },
  'icon-hide': { light: iconHideLight, dark: iconHideDark },
  'icon-passport': { light: iconPassportLight, dark: iconPassportDark },
  'icon-show': { light: iconShowLight, dark: iconShowDark },
  laptopIcon: { light: laptopIconLight, dark: laptopIconDark },
  lightGreyInfoIcon: {
    light: lightGreyInfoIconLight,
    dark: lightGreyInfoIconDark,
  },
  limitedCompanyIcon: {
    light: limitedCompanyIconLight,
    dark: limitedCompanyIconDark,
  },
  manage: { light: manageLight, dark: manageDark },
  mobileChecklistIcon: {
    light: mobileChecklistIconLight,
    dark: mobileChecklistIconDark,
  },
  moneyStacksIcon: { light: moneyStacksIconLight, dark: moneyStacksIconDark },
  'more-meatball-menu': {
    light: moreMeatballMenuLight,
    dark: moreMeatballMenuDark,
  },
  myPensionsIconGrey: {
    light: myPensionsIconGreyLight,
    dark: myPensionsIconGreyDark,
  },
  myPensionsIconYellow: {
    light: myPensionsIconYellowLight,
    dark: myPensionsIconYellowDark,
  },
  noNetworkConnection: {
    light: noNetworkConnectionLight,
    dark: noNetworkConnectionDark,
  },
  pastPerformanceIcon: {
    light: pastPerformanceIconLight,
    dark: pastPerformanceIconDark,
  },
  planningIconGrey: {
    light: planningIconGreyLight,
    dark: planningIconGreyDark,
  },
  planningIconYellow: {
    light: planningIconYellowLight,
    dark: planningIconYellowDark,
  },
  'pension-confident-podcast-logo': {
    light: pensionConfidentPodcastLogoLight,
    dark: pensionConfidentPodcastLogoDark,
  },
  pensionbeeLogo: { light: pensionbeeLogoLight, dark: pensionbeeLogoDark },
  'pensionbeelogo-transparent': {
    light: pensionbeelogoTransparentLight,
    dark: pensionbeelogoTransparentDark,
  },
  'piggy-bank': { light: piggyBankLight, dark: piggyBankDark },
  piggyBankIcon: { light: piggyBankIconLight, dark: piggyBankIconDark },
  pinIcon: { light: pinIconLight, dark: pinIconDark },
  planInfoIcon: { light: planInfoIconLight, dark: planInfoIconDark },
  play: { light: playLight, dark: playDark },
  playIcon: { light: playIconLight, dark: playIconDark },
  podcastIcon: { light: podcastIconLight, dark: podcastIconDark },
  'portfolio-money': { light: portfolioMoneyLight, dark: portfolioMoneyDark },
  profileIcon: { light: profileIconLight, dark: profileIconDark },
  referAFriendIcon: { light: referAFriendLight, dark: referAFriendDark },
  retirementPlannerIcon: {
    light: retirementPlannerIconLight,
    dark: retirementPlannerIconDark,
  },
  'spot-chat': { light: spotChatLight, dark: spotChatDark },
  'spot-checking-details': {
    light: spotCheckingDetailsLight,
    dark: spotCheckingDetailsDark,
  },
  'spot-combine-pensions': {
    light: spotCombinePensionsLight,
    dark: spotCombinePensionsDark,
  },
  'spot-customer-service': {
    light: spotCustomerServiceLight,
    dark: spotCustomerServiceDark,
  },
  'spot-deny': { light: spotDenyLight, dark: spotDenyDark },
  'spot-diverse-portfolio': {
    light: spotDiversePortfolioLight,
    dark: spotDiversePortfolioDark,
  },
  'spot-expert': { light: spotExpertLight, dark: spotExpertDark },
  'spot-expert-approved': {
    light: spotExpertApprovedLight,
    dark: spotExpertApprovedDark,
  },
  'spot-gold': { light: spotGoldLight, dark: spotGoldDark },
  'spot-icons-60px': { light: spotIcons60pxLight, dark: spotIcons60pxDark },
  'spot-laptop': { light: spotLaptopLight, dark: spotLaptopDark },
  'spot-laptop-compare': {
    light: spotLaptopCompareLight,
    dark: spotLaptopCompareDark,
  },
  'spot-money-balancing': {
    light: spotMoneyBalancingLight,
    dark: spotMoneyBalancingDark,
  },
  'spot-monitoring': { light: spotMonitoringLight, dark: spotMonitoringDark },
  'spot-phone': { light: spotPhoneLight, dark: spotPhoneDark },
  'spot-piggy-bank': { light: spotPiggyBankLight, dark: spotPiggyBankDark },
  'spot-plus-sign': { light: spotPlusSignLight, dark: spotPlusSignDark },
  'spot-remote-working': {
    light: spotRemoteWorkingLight,
    dark: spotRemoteWorkingDark,
  },
  'spot-search': { light: spotSearchLight, dark: spotSearchDark },
  'spot-self-employed': {
    light: spotSelfEmployedLight,
    dark: spotSelfEmployedDark,
  },
  'spot-thumb-up': { light: spotThumbUpLight, dark: spotThumbUpDark },
  'spot-tick': { light: spotTickLight, dark: spotTickDark },
  'spot-transfer-money': {
    light: spotTransferMoneyLight,
    dark: spotTransferMoneyDark,
  },
  'spot-verify-identity': {
    light: spotVerifyIdentityLight,
    dark: spotVerifyIdentityDark,
  },
  'spot-village': { light: spotVillageLight, dark: spotVillageDark },
  'spot-withdraw': { light: spotWithdrawLight, dark: spotWithdrawDark },
  'spot-youtube-video': {
    light: spotYoutubeVideoLight,
    dark: spotYoutubeVideoDark,
  },
  summaryIconGrey: { light: summaryIconGreyLight, dark: summaryIconGreyDark },
  summaryIconYellow: {
    light: summaryIconYellowLight,
    dark: summaryIconYellowDark,
  },
  supportIcon: { light: supportIconLight, dark: supportIconDark },
  telephoneYellowIcon: {
    light: telephoneYellowIconLight,
    dark: telephoneYellowIconDark,
  },
  thumbsUpIcon: { light: thumbsUpIconLight, dark: thumbsUpIconDark },
  tooltip: { light: tooltipLight, dark: tooltipDark },
  transferAndContributionBreakdownIcon: {
    light: transferAndContributionBreakdownIconLight,
    dark: transferAndContributionBreakdownIconDark,
  },
  'trust-pilot-logo': { light: trustPilotLogoLight, dark: trustPilotLogoDark },
  'trust-pilot-stars': {
    light: trustPilotStarsLight,
    dark: trustPilotStarsDark,
  },
  twoFAIcon: { light: twoFAIconLight, dark: twoFAIconDark },
  'up-filled': { light: upFilledLight, dark: upFilledDark },
  'upload-successful': {
    light: uploadSuccessfulLight,
    dark: uploadSuccessfulDark,
  },
  worldwide: { light: worldwideLight, dark: worldwideDark },
  hsbc: { light: hsbcLight, dark: hsbcDark },
  'black-rock': { light: blackRockLight, dark: blackRockDark },
  'state-street': { light: stateStreetLight, dark: stateStreetDark },
  plaid: { light: plaidLight, dark: plaidDark },
  pwResetIcon: { light: pwResetIconLight, dark: pwResetIconDark },
} as const satisfies Record<string, { light: string; dark: string }>;

export type ThemedImageName = keyof typeof themedImages;
